import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { OverallDataContext } from '../../pages/CalculatorPage';

export default function RadioSelectField({ id_name, category, onChangeHandler, options, setFocus, isRequired, isReadOnly }) {
    const placeholderData = useContext(OverallDataContext).placeholderData;
    const calcStage = useContext(OverallDataContext).calcStage[0];
    
    const [fieldValue, setFieldValue] = useState('');

    const handleOnChange = (field_value) => {
        setFieldValue(field_value)
        let fieldData = {
            name: id_name,
            value: field_value,
        }
        onChangeHandler(fieldData);
    }

    useEffect(()=>{
        let stateVal = placeholderData?.[category]?.[id_name] || '';
        if (stateVal && calcStage!==1) setFieldValue(stateVal);
        else setFieldValue('');
    },[calcStage, placeholderData, id_name])

    return (
        <RadioGroup
            name={ id_name } id={ id_name } 
            value={fieldValue}
            onChange={(event, newValue) => handleOnChange(newValue)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            sx={{ justifyContent: 'start' }}
            color="primary"
        >
            {
                options.map((opt, idx) => {
                    const opt_label = opt.label ? opt.label : opt.value;
                    return (
                        <FormControlLabel 
                            key={idx} 
                            value={opt.value} 
                            label={opt_label} 
                            control={
                                <Radio 
                                    disabled={isReadOnly} 
                                    required={isRequired}
                                />
                            } 
                        />
                    )
                })
            }
        </RadioGroup>
    )
}